export * from './MenuHeaderDetailsTextItem';
